function useLimitedSpaceConstructorLayout(layout, space) {
  if (!space) {
    return layout;
  }
  if (!layout.items) {
    return layout;
  }
  return {
    ...layout,
    items: layout.items.filter((item) => !item.space || item.space === space)
  };
}
export {
  useLimitedSpaceConstructorLayout
};
